var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconFillTextToImageAllProduct = function SvgS2IconFillTextToImageAllProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 97 97"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "s2_icon_fill_text_to_image_all_product_svg__a",
    width: 94,
    height: 74,
    x: 1,
    y: 13,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M86.327 31.553a2.524 2.524 0 0 0-2.266.606l-4.103 3.781c-1.82 1.68-4.718.007-4.175-2.41l1.224-4.445c.184-1.808-.044-2.657-.605-3.266l-3.781-4.103c-1.68-1.82-.007-4.718 2.41-4.175l5.445 1.224a2.523 2.523 0 0 0 2.266-.606l4.103-3.78c1.82-1.68 4.718-.007 4.175 2.41l-1.224 5.445a2.523 2.523 0 0 0 .606 2.266l3.78 4.103c1.68 1.82.007 4.718-2.41 4.175l-5.445-1.224ZM11.041 31.598h52.8c5.304 0 9.6 4.296 9.6 9.6v36c0 5.304-4.296 9.6-9.6 9.6h-52.8a9.597 9.597 0 0 1-9.6-9.6v-36c0-5.304 4.296-9.6 9.6-9.6Zm-.594 50.07h53.988c2.85 0 4.566-3.15 3.03-5.544L58.64 62.378c-1.416-2.208-4.644-2.208-6.06 0l-9.684 15.084-15.138-23.58c-1.416-2.208-4.644-2.208-6.06 0L7.417 76.124c-1.536 2.394.18 5.544 3.03 5.544ZM64.803 50.12c1.509.34 2.556-1.471 1.505-2.61l-2.666-2.891a1.582 1.582 0 0 1-.38-1.417l.866-3.838c.34-1.509-1.471-2.556-2.61-1.506l-2.891 2.667c-.382.35-.91.493-1.417.38l-3.838-.866c-1.509-.34-2.556 1.471-1.505 2.61l2.666 2.891c.35.382.493.91.38 1.417l-.866 3.838c-.34 1.509 1.471 2.556 2.61 1.505l2.891-2.666c.382-.35.91-.493 1.417-.38l3.838.866Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#s2_icon_fill_text_to_image_all_product_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s2_icon_fill_text_to_image_all_product_svg__b",
    width: 103,
    height: 97,
    x: -8,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.13 1.2H-4.248a2.81 2.81 0 0 0-2.81 2.81v90.531a2.81 2.81 0 0 0 2.81 2.811h96.379a2.81 2.81 0 0 0 2.81-2.81V4.01a2.81 2.81 0 0 0-2.81-2.81Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s2_icon_fill_text_to_image_all_product_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFECCF",
    d: "M92.13 1.2H-4.248a2.81 2.81 0 0 0-2.81 2.81v90.531a2.81 2.81 0 0 0 2.81 2.811h96.379a2.81 2.81 0 0 0 2.81-2.81V4.01a2.81 2.81 0 0 0-2.81-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFECCF",
    d: "M94.941 1.2h-102v96.152h102V1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s2_icon_fill_text_to_image_all_product_svg__c)",
    d: "M50.676 46.761c24.508-.032 44.348-18.787 44.314-41.89-.034-23.103-19.93-41.806-44.438-41.773C26.044-36.87 6.205-18.115 6.24 4.988c.034 23.103 19.93 41.806 44.437 41.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s2_icon_fill_text_to_image_all_product_svg__d)",
    d: "M31.873-15.784c-7.834-4.57-17.759-4.597-25.621-.072l-78.64 45.263c-7.703 4.433-7.715 14.896-.024 19.346l78.12 45.199c7.851 4.541 17.777 4.536 25.62-.016l77.96-45.241c7.651-4.44 7.665-14.846.023-19.303L31.873-15.784Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s2_icon_fill_text_to_image_all_product_svg__e)",
    d: "M7.64 46.852c1.744-35.896 34.027-63.664 72.107-62.02 38.079 1.643 67.535 32.075 65.792 67.972-1.743 35.896-34.026 63.664-72.105 62.021-38.08-1.644-67.536-32.076-65.793-67.973Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s2_icon_fill_text_to_image_all_product_svg__f)",
    d: "M-48.383 70.519c15.136-6.088 31.46-5.827 45.604-.502 28.301 10.68 44.769 4.077 56.19-22.54 5.69-13.357 16.797-24.67 31.951-30.763 30.297-12.166 65.275 1.035 78.162 29.51 12.887 28.477-1.219 61.398-31.509 73.579-15.188 6.108-31.544 5.822-45.709.45-28.255-10.624-44.691-3.996-56.098 22.654-5.704 13.325-16.809 24.598-31.946 30.685-30.273 12.175-65.25-1.026-78.13-29.486-12.88-28.46 1.211-61.413 31.484-73.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s2_icon_fill_text_to_image_all_product_svg__g)",
    d: "M89.058 60.402c24.508-.032 44.348-18.787 44.314-41.89-.035-23.103-19.93-41.806-44.438-41.774-24.508.033-44.348 18.788-44.313 41.89.034 23.104 19.93 41.806 44.437 41.774Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "s2_icon_fill_text_to_image_all_product_svg__d",
    x1: -32.692,
    x2: 127.709,
    y1: 87.127,
    y2: -16.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8480FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8480FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s2_icon_fill_text_to_image_all_product_svg__e",
    x1: 100.388,
    x2: 33.726,
    y1: 18.912,
    y2: 94.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s2_icon_fill_text_to_image_all_product_svg__f",
    x1: 13.933,
    x2: 136.382,
    y1: 100.975,
    y2: 28.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7D00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#FC7D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#FC7D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7D00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s2_icon_fill_text_to_image_all_product_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.06199 41.83175 -44.37555 .06576 50.614 4.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FF709F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF709F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s2_icon_fill_text_to_image_all_product_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.06199 41.83175 -44.37555 .06576 88.996 18.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#EB1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1000",
    stopOpacity: 0
  })))));
};
export default SvgS2IconFillTextToImageAllProduct;